<ckeditor [editor]="editor" [config]="config" [(ngModel)]="data" (ngModelChange)="change($event)" (ready)="onReady()"></ckeditor>